import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=732f92fe&scoped=true"
import script from "./SearchProducts.vue?vue&type=script&lang=js"
export * from "./SearchProducts.vue?vue&type=script&lang=js"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=732f92fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f92fe",
  null
  
)

export default component.exports